import React from "react";

interface AusentismoBranchRowProps {
  record: {
    id: number;
    branch: string;
    totalFaltas: number;
    percentage: number;
    details?: any[];
  };
  onShowDetails?: (branchName: string, details: any[]) => void;
}

const AusentismoBranchRow: React.FC<AusentismoBranchRowProps> = ({
  record,
  onShowDetails,
}) => {
  return (
    <tr style={{ borderBottom: "1px solid #f3f4f6" }}>
      <td className="py-2 px-4 text-start">
        <span
          style={{
            color: "#1f2937",
            fontWeight: 600,
            fontSize: "0.9rem",
          }}
        >
          {record.branch}
        </span>
      </td>
      <td className="py-2 px-4 text-start">
        <div className="d-flex justify-content-start">
          <span
            className="rounded-circle d-flex align-items-center justify-content-center"
            onClick={() =>
              onShowDetails &&
              onShowDetails(record.branch, record.details || [])
            }
            style={{
              width: "32px",
              height: "32px",
              backgroundColor: "#fef2f2",
              color: "#dc2626",
              fontWeight: 700,
              fontSize: "0.85rem",
              border: "1px solid #fecaca",
              cursor: onShowDetails ? "pointer" : "default",
              transition: "transform 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.1)")
            }
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            {record.totalFaltas}
          </span>
        </div>
      </td>
      <td className="py-2 px-4 text-start">
        <span
          className="px-3 py-1 rounded-pill"
          style={{
            backgroundColor: "#fff7ed",
            color: "#c2410c",
            fontSize: "0.75rem",
            fontWeight: "600",
            border: "1px solid #ffedd5",
          }}
        >
          {record.percentage.toFixed(2)}%
        </span>
      </td>
    </tr>
  );
};

export default AusentismoBranchRow;
